module.exports = __webpack_public_path__ + "img/env-company-pic2.58427198.png";